module.exports = __webpack_public_path__ + "static/media/logo.b20bb007.png";